import { toast } from "react-toastify";

const notify = (
  msg,
  type = "default",
  hideProgressBar = true,
  autoClose = 3000
) => {
  const toastFunction = toast[type] || toast;
  toastFunction(msg, {
    hideProgressBar: hideProgressBar,
    autoClose: autoClose,
    theme: "light",
    style: {
      fontFamily: "Outfit, sans-serif",
      fontWeight: "500",
      borderRadius: "4px",
      marginTop: "15px",
      fontSize: "1rem",
    },
  });
};

export default notify;
